import HeaderAuth from "../headerAuthenticated/HeaderAuthenticated.vue"
import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"
import '../../mixins.js'
import spinner from "../LoadingComponent/LoadingComponent.vue"
import SideBar from "../SideBar/SideBar.vue"
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'account-page',
  components: {
    HeaderAuth: HeaderAuth,
    responsivefooter: ResponsiveFooter,
    spinner: spinner,
    SideBar,
    CookieLaw
  },
  props: [],
  data () {
    return {
      isMobileView: false,
      isPortfolioEmpty: false,
      isLoaded: false,
      portfolios: [],
      createPortfolio:[],
      isModalDeleteVisible: false,
      portfolioIndex: null,
      tokenValid: false,
      isEndpointError: false,
      isModalChangeNameVisible: false,
      newPortfolioName: '',
      isNameChangeValid: {
        uniqueName:true,
        isEmpty:true
      }
    }
  },
  computed: {

  },
  async created() {
    await this.verifyToken();
    if(this.tokenValid){
      try{
        await this.retrievePortfolios();
        if(this.portfolios.length === 0){
          this.isPortfolioEmpty = true;
        }
      }catch{
        this.showErrorNotification();
      }

      this.isLoaded = true;
      this.handleView();
      window.addEventListener('resize', this.handleView);
    }

  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleView);
  },
  mounted () {

  },
  /*watch: { // function that monitors if variable is token is valid
    tokenValid: async function (val) {
      if (val == true){
        this.handleView();
        window.addEventListener('resize', this.handleView);
        await this.retrievePortfolios();
        if(this.portfolios.length === 0){
          this.isPortfolioEmpty = true;
        }
        this.isLoaded = true;

      }
    } 
  },*/
  methods: {
    async retrievePortfolios(){
      this.portfolios = await this.accessEndpointNoVerify('portfolios/?format=json')
    },
    routePortfolio(portfolioIndex){
      console.log("clicked")
      this.$router.push(
        {
          path: '/portfolio/' + this.portfolios[portfolioIndex].portfolio_id
        }
     )
    },
    validateNameChange: function(){
      this.isNameChangeValid.uniqueName = true;
      this.portfolios.forEach( portfolio => {
        if (portfolio['portfolio_name'] == this.newPortfolioName){
          console.log(portfolio['portfolio_name'])
          console.log(portfolio['portfolio_name'])
          this.isNameChangeValid.uniqueName = false
          console.log(this.isNameChangeValid)
        }
      })
      if(this.newPortfolioName == ''){
        this.isNameChangeValid.isEmpty = false
      }else{
        this.isNameChangeValid.isEmpty = true
      }
    },
    async addPortfolio(){
      this.isLoaded = false;
      try{
        await this.accessEndpoint('addPortfolio/?format=json');
        await this.retrievePortfolios();
        this.isPortfolioEmpty = false;
      }catch{
        this.showErrorNotification()
      }
      this.isLoaded = true;
    },
    async deletePortfolio(){
      this.closeModal();
      this.isLoaded = false;
      let delPortfolio = this.portfolios[this.portfolioIndex]["portfolio_id"]
      await this.deleteEndpoint('deletePortfolio/?format=json&portfolio_id=' + delPortfolio, {});
      await this.retrievePortfolios();
      this.portfolioIndex = null;
      this.isLoaded = true;
    },
    openModal: function(portfolioIndex){
      this.isModalDeleteVisible = true;
      this.portfolioIndex = portfolioIndex;
    },
    closeModal: function(){
      this.isModalDeleteVisible = false;
    },
    handleView() {
      this.isMobileView = window.innerWidth <= 800;
    },
    openChangeNameModal: function(portfolioIndex){
      this.isModalChangeNameVisible = true;
      this.portfolioIndex = portfolioIndex;
    },
    closeChangeNameModal: function(){
      this.isModalChangeNameVisible = false;
      this.portfolio_name = ''
      this.newPortfolioName = ''
    },
    changePortfolioName: async function(){
      try{
        this.validateNameChange();
        for (var keyCheck in this.isNameChangeValid) {
          if(this.isNameChangeValid[keyCheck] == false){
            return "portfolio name already exists"
          }
        }
        let payload = {
          "portfolio_id": this.portfolios[this.portfolioIndex]['portfolio_id'],
          "portfolio_name": this.newPortfolioName
        }
        this.isLoaded = false;
        await this.postEndpoint(payload, 'editPortfolioName/');
        
        await this.retrievePortfolios()
        this.closeChangeNameModal()
      }catch{
        this.isLoaded = true;
        this.showErrorNotification()
      }
      this.isLoaded = true;
      this.isNameChangeValid['uniqueName'] == true;

    }

  }
}


